import axios from 'axios';

import URLS from '../../util/urls.js';

const state = {
  listaContas: [],
  contaPesquisa: {
    nome: undefined,
    pagina: 0
  },
  labelQuantidade: '',
  contaSelecionada: {
    id: 0,
    status: '',
    banco: '',
    nome: '',
    titular: '',
    agencia: '',
    digitoAgencia: '',
    conta: '',
    digitoConta: '',
    convenioBoleto: '',
    digitoConvenioBoleto: '',
    codigoEmpresa: '',
    carteiraBoleto: '',
    numeracaoRemessa: 0,
    gerarBoletoHibrido: false,
    webhooks: []
  }
};

const mutations = {
  atualizarListaContas(state, payload) {
    if(state.contaPesquisa.pagina === 0) {
      state.listaContas = payload.lista;
    } else {
      state.listaContas.push(...payload.lista);
    }
    state.labelQuantidade = `${payload.lista.length} ${payload.lista.length === 1 ? "Conta Bancária encontrada" : "Contas Bancárias encontradas"}`;
  },
  limparContasListadas(state) {
    state.listaContas = []
  },
  limparContaPesquisa(state) {
    state.contaPesquisa = {
      nome: undefined,
      pagina: 0
    }
  },
  atualizarContaSelecionada(state, payload) {
    state.contaSelecionada = {...state.contaSelecionada, ...payload};
  },
  novaConta(state) {
    state.contaSelecionada = {
      id: 0,
      status: '',
      banco: '',
      nome: '',
      titular: '',
      agencia: '',
      digitoAgencia: '',
      conta: '',
      digitoConta: '',
      convenioBoleto: '',
      digitoConvenioBoleto: '',
      codigoEmpresa: '',
      carteiraBoleto: '',
      numeracaoRemessa: 0,
      gerarBoletoHibrido: false,
      webhooks: []
    };
  },
  limparWebhooks(state) {
    state.contaSelecionada.webhooks = [];
  },
  preencherWebhooks(state, payload) {
    state.contaSelecionada.webhooks.push(...payload);
  }
};

const actions = {
  listarContas(context, payload) {
    return axios.post(URLS.CONTAS_BANCARIAS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaContas', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('listarContas', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  limparContasListadas(context) {
    context.commit('limparContasListadas');
  },
  limparContaPesquisa(context) {
    context.commit('limparContaPesquisa');
  },
  recuperarConta(context, payload) {
    return axios.post(URLS.CONTAS_BANCARIAS_RECUPERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaSelecionada', response.data.item);
            return response.data
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('recuperarConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  novaConta(context) {
    context.commit('novaConta');
  },
  gravarConta(context, payload) {
    return axios.post(URLS.CONTAS_BANCARIAS_GRAVAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaSelecionada', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  removerConta(context, payload) {
    return axios.post(URLS.CONTAS_BANCARIAS_REMOVER,payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novaConta');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('removerConta', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },

  listarWebhooksAsaas(context, payload) {
    context.commit('limparWebhooks');

    return axios.post(URLS.CONTAS_BANCARIAS_LISTAR_WEBHOOKS_ASAAS, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('preencherWebhooks', response.data.lista)
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch('listarWebhooksAsaas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },

  removerWebhook(context, payload) {
    return axios.post(URLS.CONTAS_BANCARIAS_REMOVER_WEBHOOK_ASAAS, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch('removerWebhook', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  novoWebhookPagamentosAsaas(context, payload) {
    return axios.post(URLS.CONTAS_BANCARIAS_ADICIONAR_WEBHOOK_PAGAMENTOS, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SUCESSO':
          return response.data;
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status === "SUCESSO") {
              return context.dispatch('novoWebhookPagamentosAsaas', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    })
  }
};

export default {
  state,
  mutations,
  actions
}